import { useTranslation } from 'react-i18next';
import { useMemo } from 'react';


const formatTeacherName = (teacher) => {
  if (!teacher?.person) return '–';
  const { title_before, first_name, last_name, title_after } = teacher.person;
  const parts = [title_before, first_name, last_name].filter(Boolean);
  const name = parts.join(' ');
  return title_after ? `${name}, ${title_after}` : name;
};

// Builds basic information rows for an Ing project, similar to useFoEventBasicInformation
// Long-form texts (description, notes) are rendered separately in IngProjectsDetail
export function useIngProjectsBasicInformation(projectDetail, isStudent) {
  const { t } = useTranslation();

  return useMemo(() => {
    if (!projectDetail) return [];

    const teachers = projectDetail.teachers || [];
    const guarantorFromId = Number.isFinite(Number(projectDetail.guarantor_id))
      ? teachers.find((teacher) => Number(teacher.id) === Number(projectDetail.guarantor_id))
      : null;
    const guarantors =
      teachers.filter((teacher) => teacher.pivot?.is_guarantor === 'Áno')
        .length > 0
        ? teachers.filter((teacher) => teacher.pivot?.is_guarantor === 'Áno')
        : guarantorFromId
          ? [guarantorFromId]
          : [];

    const guarantorNames = guarantors.map(formatTeacherName).join(', ') || '–';
    const guarantorIds = new Set(guarantors.map((teacher) => Number(teacher.id)));
    const additionalTeachers = teachers.filter(
      (teacher) => !guarantorIds.has(Number(teacher.id)),
    );
    const additionalTeacherNames =
      additionalTeachers.map(formatTeacherName).join(', ') || '–';

    const studyPrograms = projectDetail.study_programs || [];
    const studyProgramsList =
      studyPrograms.length > 0
        ? studyPrograms
            .map((program) => {
              const isWaiting = program.pivot?.approved === null;
              const approved = program.pivot?.approved === 'Áno';
              const statusText = isWaiting ? t('Čaká na schválenie') : approved ? t('Schválený') : t('Neschválený');

              if (isStudent) {
                return `
                  <div style="margin-bottom: 8px;">
                    <span style="margin-right: 8px;">${program.name} (${program.shortcut})</span>
                  </div>
                `;
              } else {
                return `
              <div style="margin-bottom: 8px;">
                <span style="margin-right: 8px;">${program.name} (${program.shortcut})</span>
                <span style="
                  display: inline-block;
                  padding: 2px 8px;
                  background-color: ${isWaiting ? '#fff7e6' : approved ? '#f6ffed' : '#fff2f0'};
                  border: 1px solid ${isWaiting ? '#dbb18a' : approved ? '#b7eb8f' : '#ffccc7'};
                  color: ${isWaiting ? '#d46b08' : approved ? '#52c41a' : '#ff4d4f'};
                  border-radius: 4px;
                  font-size: 12px;
                ">${statusText}</span>
              </div>
            `;
              }

            })


            .join('')
        : '–';

    return [
      {
        label: t('Názov projektu'),
        value: projectDetail.name,
      },
      {
        label: t('Skratka'),
        value: projectDetail.shortcut,
      },
      {
        label: t('Garant'),
        value: guarantorNames,
      },
      {
        label: t('Ďalší učitelia'),
        value: additionalTeacherNames,
      },
      {
        label: t('Študijné programy'),
        value: studyProgramsList,
        isRaw: true,
      },
      {
        label: t('Počet študentov'),
        value:
          (projectDetail.min_students ?? '-') +
          ' - ' +
          (projectDetail.max_students ?? '-'),
      },
    ];
  }, [isStudent, projectDetail, t]);
}
